// RichIframe.jsx
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import { dispatchGlobalClickIfNeeded } from '../resource/createTrackingEvent.js';
import { NULL_FUNCTION } from '../resource/defaults.js';
import {
  IFRAME_SANDBOX_FLAGS,
  IFRAME_ALLOW_FEATURES,
} from '../RemoteConfigKeys.js';

export const RichIframe = ({
  onLoad = NULL_FUNCTION,
  onClickContentWindow = NULL_FUNCTION,
  ...restIframeAttributes
}) => {
  const trackingPayload = restIframeAttributes?.['data-tracking_payload'];
  const handleClick = clickEvent => {
    dispatchGlobalClickIfNeeded(clickEvent, 'IFRAME', trackingPayload);
    onClickContentWindow(clickEvent);
  };

  // sandbox / allow default to the remote-config values (env/* + GrowthBook).
  // They sit before the spread below so a caller can override them — e.g. games
  // pass sandbox={null} to opt out (no sandbox).
  const sandboxFlags = useSelector(state =>
    getRemoteConfigData(state, IFRAME_SANDBOX_FLAGS)
  );
  const allowFeatures = useSelector(state =>
    getRemoteConfigData(state, IFRAME_ALLOW_FEATURES)
  );
  const sandbox = sandboxFlags.join(' ');
  const allow = allowFeatures.join('; ');

  return (
    <StyledRichIframe
      onLoad={e => {
        if (e.target?.contentWindow) {
          try {
            e.target?.contentWindow.addEventListener('click', handleClick);
          } catch (_) {
            // skip cross-origin frame issue
          }
        }
        onLoad(e);
      }}
      title="rich text content"
      sandbox={sandbox}
      allow={allow}
      {...restIframeAttributes}
    />
  );
};

RichIframe.propTypes = {
  onLoad: PropTypes.func,
  onClickContentWindow: PropTypes.func,
};

// eslint-disable-next-line swag/no-native-iframe
const StyledRichIframe = styled.iframe`
  width: 100%;
  height: 100%;
`;

export default RichIframe;
